// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PaginationLargeCircleArrowRight: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    className?: string;
}> = ({ size = 36, color1 = "#fff", color2 = "#577538", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 36 36" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <circle cx="18" cy="18" r="18" fill="currentColor" fillOpacity=".9" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M18 0c9.941 0 18 8.059 18 18s-8.059 18-18 18S0 27.941 0 18 8.059 0 18 0m0 .5C8.335.5.5 8.335.5 18S8.335 35.5 18 35.5 35.5 27.665 35.5 18 27.665.5 18 .5"
            />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M23.758 18.578a.81.81 0 0 0 0-1.156L15.42 9.238a.85.85 0 0 0-1.178 0 .81.81 0 0 0 0 1.156L21.992 18l-7.75 7.606a.81.81 0 0 0 0 1.156.85.85 0 0 0 1.178 0z"
            />
        </g>
    </svg>
);

export default React.memo(PaginationLargeCircleArrowRight);
